import { Button } from '@strata/react-buttons';
import { WarningDialog } from '@strata/react-dialog';
import { Grid, PrimaryData } from '@strata/react-grid';
import { SuccessToast } from '@strata/react-toast-message';
import PropTypes from 'prop-types';
import { useState } from 'react';

import { handleError } from 'services/ErrorManagement';
import { httpDelete } from 'services/Http';

const columns = [
    {
        header: 'Product',
        accessorKey: 'product',
        size: 150,
        cell: ({ getValue }) => <PrimaryData data={getValue()} />,
    },
    {
        header: 'Payer',
        accessorKey: 'payer_id',
        size: 60,
    },
    {
        header: 'Product Type',
        accessorKey: 'productType',
        size: 80,
    },
    {
        header: 'Benefit',
        accessorKey: 'benefit',
        size: 75,
    },
    {
        header: 'POS',
        accessorKey: 'placeOfService',
        size: 90,
    },
];

export const DeleteRateRuleDialog = ({ ruleToDelete = undefined, onClose, onDeleteSuccess }) => {
    const [isDeleting, setIsDeleting] = useState(false);
    return (
        <WarningDialog
            dialogTitle="Confirm Delete Rate Rule"
            width={700}
            isOpen={!!ruleToDelete}
            primaryButtonLabel="Yes, Delete Rate Rule"
            primaryButtonIntent={Button.Intent.DANGER}
            primaryButtonDisabled={isDeleting}
            onPrimaryButtonClick={async () => {
                try {
                    setIsDeleting(true);

                    await httpDelete(`/ratesetter/admin/rate_rules/${ruleToDelete?.rate_rule_id}`);

                    SuccessToast({ message: 'Rate rule deleted successfully.' });
                    onDeleteSuccess();
                    onClose();
                } catch (err) {
                    handleError('Error deleting rate rule.', err);
                } finally {
                    setIsDeleting(false);
                }
            }}
            secondaryButtonLabel="No, Return To Rate Rules"
            onSecondaryButtonClick={onClose}
            dialogContent={
                <>
                    <div className="margin__bottom--large">
                        Are you sure you want to delete the following rate rule?
                    </div>
                    <Grid data={[ruleToDelete]} enableSorting={false} columns={columns} />
                </>
            }
        />
    );
};

DeleteRateRuleDialog.propTypes = {
    ruleToDelete: PropTypes.shape({ rate_rule_id: PropTypes.string.isRequired }),
    onClose: PropTypes.func.isRequired,
    onDeleteSuccess: PropTypes.func.isRequired,
};
